import { T_SUBSCRIPTION_CARD_PAGE_CONSTANTS } from './TYPES'

const EN_SUBSCRIPTION_CARD_PAGE_CONSTANTS: T_SUBSCRIPTION_CARD_PAGE_CONSTANTS =
  {
    CHAMPION: {
      TITLE: 'Champion',
      DESCRIPTION: 'Best Choice for {{minUser}}+ users',
      TENURE_LABEL_TEXT: 'Choose Period',
      TENURES_MAP: {
        6: '6 months',
        12: '1 year',
        LIFETIME: 'Lifetime'
      },
      YOU_WILL_PAY_TEXT: 'YOU WILL PAY',
      YOU_WILL_PAY_USER_TEXT: 'user',
      BUY_CTA_TEXT: 'Buy Plan'
    },
    PREMIUM: {
      TITLE: 'Premium',
      DESCRIPTION: 'Best Choice for {{minUser}}+ users',
      TENURE_LABEL_TEXT: 'Choose Period',
      TENURES_MAP: {
        6: '6 months',
        12: '1 year',
        LIFETIME: 'Lifetime'
      },
      YOU_WILL_PAY_TEXT: 'YOU WILL PAY',
      YOU_WILL_PAY_USER_TEXT: 'user',
      BUY_CTA_TEXT: 'Buy Plan'
    },
    ADVENTURE: {
      TITLE: 'Adventure',
      DESCRIPTION: 'Best Choice for Individuals',
      TENURE_LABEL_TEXT: 'Choose Period',
      TENURES_MAP: {
        6: '6 months',
        12: '1 year',
        LIFETIME: 'Lifetime'
      },
      YOU_WILL_PAY_TEXT: 'YOU WILL PAY',
      YOU_WILL_PAY_USER_TEXT: 'user',
      BUY_CTA_TEXT: 'Buy Plan'
    }
  }

export default EN_SUBSCRIPTION_CARD_PAGE_CONSTANTS
